export default __webpack_public_path__ + "images/37_2_image.jpg";